<footer class="footer-bar">
<div class="row footer-row" *ngIf="service.getFooter$ | async as footer">
  <div class="col-md-12 mid-logo-area">
    <div [innerHtml]="footer.copyrights"></div>
    <div [innerHtml]="footer.contactUs"></div>
    <div [innerHtml]="footer.privacyPolicy"></div>
  </div>
</div>
</footer>
